import { render } from "./LivroView.vue?vue&type=template&id=73f5d790&scoped=true"
import script from "./LivroView.vue?vue&type=script&lang=js"
export * from "./LivroView.vue?vue&type=script&lang=js"

import "./LivroView.vue?vue&type=style&index=0&id=73f5d790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f5d790"]])

export default __exports__